module.exports = __webpack_public_path__ + "img/mobi_P5.8c6212bb.png";